import React from 'react'
import { OperationalContext } from '../styles'

export const ReceivingTaskContext = ({ location, pallet }: { location?: string; pallet?: string | null }) => (
  <OperationalContext aria-label="Receiving task context">
    {location ? (
      <div>
        <dt>Location</dt>
        <dd>{location}</dd>
      </div>
    ) : null}
    {pallet ? (
      <div>
        <dt>Pallet</dt>
        <dd>{pallet}</dd>
      </div>
    ) : null}
  </OperationalContext>
)
